'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["children"];

var _templateObject;
var Box = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.05);\n  display: flex;\n  height: 50px;\n  padding: 10px !important;\n"])));

// @ts-expect-error TS(2322): Type '{ children: Node; className?: string | null ... Remove this comment to see the full error message
var BriefDetailBox = function BriefDetailBox(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Box, props, children);
};

BriefDetailBox.defaultProps = {
  className: '',
  onClick: null
};

exports["default"] = BriefDetailBox;
